import { createElement } from 'react';

import {
  Beer,
  Bed,
  Bus,
  Car,
  Coffee,
  Dumbbell,
  Gamepad2,
  Gift,
  GraduationCap,
  HeartPulse,
  House,
  Plane,
  ShoppingBag,
  ShoppingCart,
  Shirt,
  Smartphone,
  Tag,
  Ticket,
  Utensils,
  Wallet,
  Wifi,
  Wrench,
  Zap,
  type LucideIcon,
} from 'lucide-react';

/**
 * Category icons are stored in the database as stable string keys rather than
 * component names, so swapping icon libraries never orphans a user's data.
 * Unknown keys fall back to `Tag`.
 */
export const CATEGORY_ICONS: Record<string, LucideIcon> = {
  utensils: Utensils,
  'shopping-cart': ShoppingCart,
  car: Car,
  bed: Bed,
  gamepad: Gamepad2,
  zap: Zap,
  'shopping-bag': ShoppingBag,
  health: HeartPulse,
  plane: Plane,
  house: House,
  wifi: Wifi,
  gift: Gift,
  school: GraduationCap,
  gym: Dumbbell,
  coffee: Coffee,
  beer: Beer,
  bus: Bus,
  tools: Wrench,
  phone: Smartphone,
  shirt: Shirt,
  ticket: Ticket,
  wallet: Wallet,
  tag: Tag,
};

export const CATEGORY_ICON_KEYS = Object.keys(CATEGORY_ICONS);

export function categoryIcon(key: string | null | undefined): LucideIcon {
  return (key && CATEGORY_ICONS[key]) || Tag;
}

/** Rounded tinted square containing the category's icon. */
export function CategoryGlyph({
  icon,
  color,
  size = 'md',
}: {
  icon: string | null | undefined;
  color: string | null | undefined;
  size?: 'sm' | 'md' | 'lg';
}) {
  const tint = color ?? '#64748b';
  const box = { sm: 'size-8 rounded-[10px]', md: 'size-10 rounded-xl', lg: 'size-14 rounded-2xl' }[size];
  const glyph = { sm: 15, md: 18, lg: 24 }[size];

  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center ${box}`}
      style={{ backgroundColor: `${tint}1f`, color: tint }}
      aria-hidden="true"
    >
      {/* `createElement` rather than <Icon />: the component is picked at
          runtime from the registry, which JSX capitalisation can't express. */}
      {createElement(categoryIcon(icon), { size: glyph, strokeWidth: 2.1 })}
    </span>
  );
}
